export const NewsData = [
    {
        id: 1,
        date: "October 7, 2024",
        src: "images/news-image-1.jpg",
        paragraph: "How to Bring Your Family to the U.S.: A Guide to Family-Based Immigration",
        href: "/how-to-bring-your-family-to-the-u-s-a-guide-to-family-based-immigration",
    },
    {
        id: 2,
        date: "October 14, 2024",
        src: "images/news-image-2.jpg",
        paragraph: "How to Win a U.S. Green Card: Understanding the DV Lottery",
        href: "/how-to-win-a-u-s-green-card-understanding-the-dv-lottery",
    },
    {
        id: 3,
        date: "October 21, 2024",
        src: "images/news-image-3.jpg",
        paragraph: "How to Study in the U.S.: Your Guide to Getting a Student Visa",
        href: "/how-to-study-in-the-u-s-your-guide-to-getting-a-student-visa",
    },
    {
        id: 4,
        date: "November 11, 2024",
        src: "images/news-image-4.jpg",
        paragraph: "Trump’s Victory and the Future of U.S. Immigration: What You Need to Know",
        href: "/trumps-victory-and-the-future-of-u-s-immigration-what-you-need-to-know",
    },
    {
        id: 5,
        date: "November 4, 2024",
        src: "images/news-image-5.jpg",
        paragraph: "Understanding the K-1 Fiancé Visa: Bringing Your Fiancé to the U.S.",
        href: "/understanding-the-k-1-fiancé-visa-bringing-your-fiancé-to-the-u-s",
    },
]